export const LOCATION_OPTIONS = [
  // --- NORTH AMERICA ---
  { value: "Bermuda", key: "bermuda", regions: ["north_america"] },
  { value: "Canada", key: "canada", regions: ["north_america"] },
  { value: "Greenland", key: "greenland", regions: ["north_america"] },
  {
    value: "Saint Pierre and Miquelon",
    key: "saint_pierre_and_miquelon",
    regions: ["north_america"],
  },
  { value: "USA", key: "usa", regions: ["north_america"] },

  // --- LATIN AMERICA ---
  { value: "Anguilla", key: "anguilla", regions: ["latin_america"] },
  {
    value: "Antigua and Barbuda",
    key: "antigua_and_barbuda",
    regions: ["latin_america"],
  },
  { value: "Argentina", key: "argentina", regions: ["latin_america"] },
  { value: "Aruba", key: "aruba", regions: ["latin_america"] },
  { value: "Bahamas", key: "bahamas", regions: ["latin_america"] },
  { value: "Barbados", key: "barbados", regions: ["latin_america"] },
  { value: "Belize", key: "belize", regions: ["latin_america"] },
  { value: "Bolivia", key: "bolivia", regions: ["latin_america"] },
  { value: "Brazil", key: "brazil", regions: ["latin_america"] },
  {
    value: "Cayman Islands",
    key: "cayman_islands",
    regions: ["latin_america"],
  },
  { value: "Chile", key: "chile", regions: ["latin_america"] },
  { value: "Colombia", key: "colombia", regions: ["latin_america"] },
  { value: "Costa Rica", key: "costa_rica", regions: ["latin_america"] },
  { value: "Cuba", key: "cuba", regions: ["latin_america"] },
  { value: "Dominica", key: "dominica", regions: ["latin_america"] },
  {
    value: "Dominican Republic",
    key: "dominican_republic",
    regions: ["latin_america"],
  },
  { value: "Ecuador", key: "ecuador", regions: ["latin_america"] },
  { value: "El Salvador", key: "el_salvador", regions: ["latin_america"] },
  {
    value: "Falkland Islands",
    key: "falkland_islands",
    regions: ["latin_america"],
  },
  { value: "Grenada", key: "grenada", regions: ["latin_america"] },
  { value: "Guadeloupe", key: "guadeloupe", regions: ["latin_america"] },
  { value: "Guatemala", key: "guatemala", regions: ["latin_america"] },
  { value: "Guyana", key: "guyana", regions: ["latin_america"] },
  { value: "Haiti", key: "haiti", regions: ["latin_america"] },
  { value: "Honduras", key: "honduras", regions: ["latin_america"] },
  { value: "Jamaica", key: "jamaica", regions: ["latin_america"] },
  { value: "Martinique", key: "martinique", regions: ["latin_america"] },
  { value: "Mexico", key: "mexico", regions: ["latin_america"] },
  { value: "Montserrat", key: "montserrat", regions: ["latin_america"] },
  { value: "Nicaragua", key: "nicaragua", regions: ["latin_america"] },
  { value: "Panama", key: "panama", regions: ["latin_america"] },
  { value: "Paraguay", key: "paraguay", regions: ["latin_america"] },
  { value: "Peru", key: "peru", regions: ["latin_america"] },
  { value: "Puerto Rico", key: "puerto_rico", regions: ["latin_america"] },
  {
    value: "Saint Kitts and Nevis",
    key: "saint_kitts_and_nevis",
    regions: ["latin_america"],
  },
  { value: "Saint Lucia", key: "saint_lucia", regions: ["latin_america"] },
  {
    value: "Saint Vincent and the Grenadines",
    key: "saint_vincent_and_the_grenadines",
    regions: ["latin_america"],
  },
  { value: "Suriname", key: "suriname", regions: ["latin_america"] },
  {
    value: "Trinidad and Tobago",
    key: "trinidad_and_tobago",
    regions: ["latin_america"],
  },
  {
    value: "Turks and Caicos Islands",
    key: "turks_and_caicos_islands",
    regions: ["latin_america"],
  },
  { value: "Uruguay", key: "uruguay", regions: ["latin_america"] },
  { value: "Venezuela", key: "venezuela", regions: ["latin_america"] },

  // --- APAC ---
  { value: "Afghanistan", key: "afghanistan", regions: ["apac"] },
  { value: "Australia", key: "australia", regions: ["apac"] },
  { value: "Bangladesh", key: "bangladesh", regions: ["apac"] },
  { value: "Bhutan", key: "bhutan", regions: ["apac"] },
  {
    value: "British Indian Ocean Territory",
    key: "british_indian_ocean_territory",
    regions: ["apac"],
  },
  { value: "Brunei", key: "brunei", regions: ["apac"] },
  { value: "Cambodia", key: "cambodia", regions: ["apac"] },
  { value: "China", key: "china", regions: ["apac"] },
  { value: "Christmas Island", key: "christmas_island", regions: ["apac"] },
  {
    value: "Cocos (Keeling) Islands",
    key: "cocos_keeling_islands",
    regions: ["apac"],
  },
  { value: "Cook Islands", key: "cook_islands", regions: ["apac"] },
  { value: "Fiji", key: "fiji", regions: ["apac"] },
  { value: "French Polynesia", key: "french_polynesia", regions: ["apac"] },
  { value: "Guam", key: "guam", regions: ["apac"] },
  {
    value: "Heard Island and McDonald Islands",
    key: "heard_island_and_mcdonald_islands",
    regions: ["apac"],
  },
  { value: "Hong Kong", key: "hong_kong", regions: ["apac"] },
  { value: "India", key: "india", regions: ["apac"] },
  { value: "Indonesia", key: "indonesia", regions: ["apac"] },
  { value: "Japan", key: "japan", regions: ["apac"] },
  { value: "Kazakhstan", key: "kazakhstan", regions: ["apac"] },
  { value: "Kiribati", key: "kiribati", regions: ["apac"] },
  { value: "Kyrgyzstan", key: "kyrgyzstan", regions: ["apac"] },
  { value: "Laos", key: "laos", regions: ["apac"] },
  { value: "Macau", key: "macau", regions: ["apac"] },
  { value: "Malaysia", key: "malaysia", regions: ["apac"] },
  { value: "Maldives", key: "maldives", regions: ["apac"] },
  { value: "Marshall Islands", key: "marshall_islands", regions: ["apac"] },
  { value: "Mongolia", key: "mongolia", regions: ["apac"] },
  { value: "Myanmar", key: "myanmar", regions: ["apac"] },
  { value: "Nauru", key: "nauru", regions: ["apac"] },
  { value: "Nepal", key: "nepal", regions: ["apac"] },
  { value: "New Caledonia", key: "new_caledonia", regions: ["apac"] },
  { value: "New Zealand", key: "new_zealand", regions: ["apac"] },
  { value: "Niue", key: "niue", regions: ["apac"] },
  { value: "Norfolk Island", key: "norfolk_island", regions: ["apac"] },
  { value: "North Korea", key: "north_korea", regions: ["apac"] },
  {
    value: "Northern Mariana Islands",
    key: "northern_mariana_islands",
    regions: ["apac"],
  },
  { value: "Pakistan", key: "pakistan", regions: ["apac"] },
  { value: "Palau", key: "palau", regions: ["apac"] },
  { value: "Papua New Guinea", key: "papua_new_guinea", regions: ["apac"] },
  { value: "Philippines", key: "philippines", regions: ["apac"] },
  { value: "Pitcairn", key: "pitcairn", regions: ["apac"] },
  { value: "Samoa", key: "samoa", regions: ["apac"] },
  { value: "Singapore", key: "singapore", regions: ["apac"] },
  { value: "Solomon Islands", key: "solomon_islands", regions: ["apac"] },
  { value: "South Korea", key: "south_korea", regions: ["apac"] },
  { value: "Sri Lanka", key: "sri_lanka", regions: ["apac"] },
  { value: "Taiwan", key: "taiwan", regions: ["apac"] },
  { value: "Thailand", key: "thailand", regions: ["apac"] },
  { value: "Timor-Leste", key: "timor-leste", regions: ["apac"] },
  { value: "Tokelau", key: "tokelau", regions: ["apac"] },
  { value: "Tonga", key: "tonga", regions: ["apac"] },
  { value: "Turkmenistan", key: "turkmenistan", regions: ["apac"] },
  { value: "Uzbekistan", key: "uzbekistan", regions: ["apac"] },
  { value: "Vanuatu", key: "vanuatu", regions: ["apac"] },
  { value: "Vietnam", key: "vietnam", regions: ["apac"] },
  { value: "Wallis and Futuna", key: "wallis_and_futuna", regions: ["apac"] },

  // --- MEA + EMEA (merged where duplicates exist) ---
  { value: "Algeria", key: "algeria", regions: ["mea", "emea"] },
  { value: "Angola", key: "angola", regions: ["mea"] },
  { value: "Bahrain", key: "bahrain", regions: ["mea"] },
  { value: "Benin", key: "benin", regions: ["mea"] },
  { value: "Botswana", key: "botswana", regions: ["mea"] },
  { value: "Burkina Faso", key: "burkina_faso", regions: ["mea"] },
  { value: "Burundi", key: "burundi", regions: ["mea"] },
  { value: "Cameroon", key: "cameroon", regions: ["mea"] },
  { value: "Cape Verde", key: "cape_verde", regions: ["mea"] },
  {
    value: "Central African Republic",
    key: "central_african_republic",
    regions: ["mea"],
  },
  { value: "Chad", key: "chad", regions: ["mea"] },
  { value: "Comoros", key: "comoros", regions: ["mea"] },
  { value: "Congo", key: "congo", regions: ["mea"] },
  { value: "Djibouti", key: "djibouti", regions: ["mea"] },
  { value: "Egypt", key: "egypt", regions: ["mea"] },
  { value: "Equatorial Guinea", key: "equatorial_guinea", regions: ["mea"] },
  { value: "Eritrea", key: "eritrea", regions: ["mea"] },
  { value: "Ethiopia", key: "ethiopia", regions: ["mea"] },
  { value: "Gabon", key: "gabon", regions: ["mea"] },
  { value: "Gambia", key: "gambia", regions: ["mea"] },
  { value: "Ghana", key: "ghana", regions: ["mea"] },
  { value: "Guinea", key: "guinea", regions: ["mea"] },
  { value: "Guinea-Bissau", key: "guinea-bissau", regions: ["mea"] },
  { value: "Iran", key: "iran", regions: ["mea"] },
  { value: "Iraq", key: "iraq", regions: ["mea"] },
  { value: "Israel", key: "israel", regions: ["mea"] },
  { value: "Ivory Coast", key: "ivory_coast", regions: ["mea"] },
  { value: "Jordan", key: "jordan", regions: ["mea"] },
  { value: "Kenya", key: "kenya", regions: ["mea"] },
  { value: "Kuwait", key: "kuwait", regions: ["mea"] },
  { value: "Lebanon", key: "lebanon", regions: ["mea"] },
  { value: "Lesotho", key: "lesotho", regions: ["mea"] },
  { value: "Liberia", key: "liberia", regions: ["mea"] },
  { value: "Libya", key: "libya", regions: ["mea"] },
  { value: "Madagascar", key: "madagascar", regions: ["mea"] },
  { value: "Malawi", key: "malawi", regions: ["mea"] },
  { value: "Mali", key: "mali", regions: ["mea"] },
  { value: "Mauritania", key: "mauritania", regions: ["mea"] },
  { value: "Mauritius", key: "mauritius", regions: ["mea"] },
  { value: "Mayotte", key: "mayotte", regions: ["mea"] },
  { value: "Morocco", key: "morocco", regions: ["mea"] },
  { value: "Mozambique", key: "mozambique", regions: ["mea"] },
  { value: "Namibia", key: "namibia", regions: ["mea"] },
  { value: "Niger", key: "niger", regions: ["mea"] },
  { value: "Nigeria", key: "nigeria", regions: ["mea"] },
  { value: "Oman", key: "oman", regions: ["mea"] },
  { value: "Qatar", key: "qatar", regions: ["mea"] },
  { value: "Rwanda", key: "rwanda", regions: ["mea"] },
  { value: "Réunion", key: "réunion", regions: ["mea"] },
  {
    value: "Sao Tome and Principe",
    key: "sao_tome_and_principe",
    regions: ["mea"],
  },
  { value: "Saudi Arabia", key: "saudi_arabia", regions: ["mea"] },
  { value: "Senegal", key: "senegal", regions: ["mea"] },
  { value: "Seychelles", key: "seychelles", regions: ["mea"] },
  { value: "Sierra Leone", key: "sierra_leone", regions: ["mea"] },
  { value: "Somalia", key: "somalia", regions: ["mea"] },
  { value: "South Africa", key: "south_africa", regions: ["mea"] },
  { value: "Sudan", key: "sudan", regions: ["mea"] },
  { value: "Suriname", key: "suriname", regions: ["mea"] }, // note: also in latin_america in your earlier big list, but here you had it under latin too.
  { value: "Swaziland", key: "swaziland", regions: ["mea"] },
  { value: "Syria", key: "syria", regions: ["mea"] },
  { value: "Tanzania", key: "tanzania", regions: ["mea"] },
  { value: "Togo", key: "togo", regions: ["mea"] },
  { value: "Tunisia", key: "tunisia", regions: ["mea"] },
  { value: "Uganda", key: "uganda", regions: ["mea"] },
  {
    value: "United Arab Emirates",
    key: "united_arab_emirates",
    regions: ["mea"],
  },
  { value: "Yemen", key: "yemen", regions: ["mea"] },
  { value: "Zambia", key: "zambia", regions: ["mea"] },
  { value: "Zimbabwe", key: "zimbabwe", regions: ["mea"] },

  // EMEA-only (from your EMEA list)
  { value: "Albania", key: "albania", regions: ["emea"] },
  { value: "Andorra", key: "andorra", regions: ["emea"] },
  { value: "Armenia", key: "armenia", regions: ["emea"] },
  { value: "Austria", key: "austria", regions: ["emea"] },
  { value: "Azerbaijan", key: "azerbaijan", regions: ["emea"] },
  { value: "Belarus", key: "belarus", regions: ["emea"] },
  { value: "Belgium", key: "belgium", regions: ["emea"] },
  {
    value: "Bosnia and Herzegovina",
    key: "bosnia_and_herzegovina",
    regions: ["emea"],
  },
  { value: "Bulgaria", key: "bulgaria", regions: ["emea"] },
  { value: "Croatia", key: "croatia", regions: ["emea"] },
  { value: "Cyprus", key: "cyprus", regions: ["emea"] },
  { value: "Czech Republic", key: "czech_republic", regions: ["emea"] },
  { value: "Denmark", key: "denmark", regions: ["emea"] },
  { value: "Estonia", key: "estonia", regions: ["emea"] },
  { value: "Faroe Islands", key: "faroe_islands", regions: ["emea"] },
  { value: "Finland", key: "finland", regions: ["emea"] },
  { value: "France", key: "france", regions: ["emea"] },
  { value: "Georgia", key: "georgia", regions: ["emea"] },
  { value: "Germany", key: "germany", regions: ["emea"] },
  { value: "Gibraltar", key: "gibraltar", regions: ["emea"] },
  { value: "Greece", key: "greece", regions: ["emea"] },
  { value: "Guernsey", key: "guernsey", regions: ["emea"] },
  { value: "Hungary", key: "hungary", regions: ["emea"] },
  { value: "Iceland", key: "iceland", regions: ["emea"] },
  { value: "Ireland", key: "ireland", regions: ["emea"] },
  { value: "Isle of Man", key: "isle_of_man", regions: ["emea"] },
  { value: "Italy", key: "italy", regions: ["emea"] },
  { value: "Jersey", key: "jersey", regions: ["emea"] },
  { value: "Kosovo", key: "kosovo", regions: ["emea"] },
  { value: "Latvia", key: "latvia", regions: ["emea"] },
  { value: "Liechtenstein", key: "liechtenstein", regions: ["emea"] },
  { value: "Lithuania", key: "lithuania", regions: ["emea"] },
  { value: "Luxembourg", key: "luxembourg", regions: ["emea"] },
  { value: "Macedonia", key: "macedonia", regions: ["emea"] },
  { value: "Malta", key: "malta", regions: ["emea"] },
  { value: "Moldova", key: "moldova", regions: ["emea"] },
  { value: "Monaco", key: "monaco", regions: ["emea"] },
  { value: "Montenegro", key: "montenegro", regions: ["emea"] },
  { value: "Netherlands", key: "netherlands", regions: ["emea"] },
  { value: "Norway", key: "norway", regions: ["emea"] },
  { value: "Poland", key: "poland", regions: ["emea"] },
  { value: "Portugal", key: "portugal", regions: ["emea"] },
  { value: "Romania", key: "romania", regions: ["emea"] },
  { value: "Russia", key: "russia", regions: ["emea"] },
  { value: "San Marino", key: "san_marino", regions: ["emea"] },
  { value: "Serbia", key: "serbia", regions: ["emea"] },
  { value: "Slovakia", key: "slovakia", regions: ["emea"] },
  { value: "Slovenia", key: "slovenia", regions: ["emea"] },
  { value: "Spain", key: "spain", regions: ["emea"] },
  { value: "Sweden", key: "sweden", regions: ["emea"] },
  { value: "Switzerland", key: "switzerland", regions: ["emea"] },
  { value: "Turkey", key: "turkey", regions: ["emea"] },
  { value: "Ukraine", key: "ukraine", regions: ["emea"] },
  { value: "United Kingdom", key: "united_kingdom", regions: ["emea"] },
  {
    value: "Vatican City State (Holy See)",
    key: "vatican_city_state_holy_see",
    regions: ["emea"],
  },

  // --- GLOBAL (this entry can stay, but global selection will show ALL anyway) ---
  {
    value: "South Georgia and the South Sandwich Islands",
    key: "south_georgia_and_the_south_sandwich_islands",
    regions: ["global"],
  },
];

export const ORGANIZATION_REGION_OPTIONS = [
  { key: "global", label: "Global" },
  { key: "apac", label: "Asia-Pacific (APAC)" },
  { key: "emea", label: "Europe, Middle East & Africa (EMEA)" },
  // { key: 'americas', label: 'Americas' },
  { key: "north_america", label: "North America" },
  { key: "latin_america", label: "Latin America" },
  { key: "mea", label: "Middle East & Africa" },
];

export const EMPLOYEE_RANGE = [
  "< 50",
  "51 - 200",
  "201 - 500",
  "501 - 1000",
  "1001 - 5000",
  "> 5000",
];

export const ANNUAL_REVENUE = [
  "< 2M",
  "2M - 10M",
  "10M - 100M",
  "100M - 500M",
  "500M - 1B",
  "> 1B",
];

export const KEY_IMPROVEMENT = [
  { key: "electricity", value: "Electricity" },
  { key: "heating", value: "Heating" },
  { key: "cooling", value: "Cooling" },
  { key: "fuel", value: "Fuel" },
  { key: "water", value: "Water" },
];

export const INDUSTRIAL_CLASSIFICATION = [
  { key: "food_081", value: "Food - 081 Processing and Preserving of Meat" },
  {
    key: "food_082",
    value:
      "Food - 082 Processing and Preserving of Fish, Crustaceans and Molluscs",
  },
  {
    key: "food_083",
    value: "Food - 083 Processing and Preserving of Fruit and Vegetables",
  },
  {
    key: "food_084",
    value:
      "Food - 084 Manufacture of Edible Vegetable and Animal Oils and Fats",
  },
  { key: "food_085", value: "Food - 085 Manufacture of Dairy Products" },
  {
    key: "food_086",
    value:
      "Food - 086 Grain Husking, Manufacture of Grain Mill Products, Starches and Starch Products",
  },
  { key: "food_087", value: "Food - 087 Manufacture of Prepared Animal Feeds" },
  { key: "food_089", value: "Food - 089 Manufacture of Other Food Products" },
  {
    key: "beverages_091",
    value: "Beverages - 091 Manufacture of Alcoholic Beverages",
  },
  {
    key: "beverages_092",
    value: "Beverages - 092 Manufacture of Non-alcoholic Beverages",
  },
  {
    key: "tobacco_100",
    value: "Tobacco - 100 Manufacture of Tobacco Products",
  },
  {
    key: "apparel_textiles_111",
    value: "Apparel & Textiles - 111 Spinning of Yarn",
  },
  {
    key: "apparel_textiles_112",
    value: "Apparel & Textiles - 112 Weaving of Textiles",
  },
  {
    key: "apparel_textiles_113",
    value: "Apparel & Textiles - 113 Manufacture of Non-woven Fabrics",
  },
  {
    key: "apparel_textiles_114",
    value: "Apparel & Textiles - 114 Finishing of Textiles",
  },
  {
    key: "apparel_textiles_115",
    value: "Apparel & Textiles - 115 Manufacture of Textile Products",
  },
  {
    key: "apparel_textiles_121",
    value: "Apparel & Textiles - 121 Manufacture of Wearing Apparel",
  },
  {
    key: "apparel_textiles_123",
    value: "Apparel & Textiles - 123 Manufacture of Clothing Accessories",
  },
  {
    key: "consumer_goods_retail_130",
    value:
      "Consumer Goods Retail - 130 Manufacture of Leather, Fur and Related Products",
  },
  {
    key: "forestry_paper_140",
    value:
      "Forestry & Paper - 140 Manufacture of Wood and of Products of Wood and Bamboo",
  },
  {
    key: "forestry_paper_151",
    value: "Forestry & Paper - 151 Manufacture of Pulp, Paper and Paperboard",
  },
  {
    key: "forestry_paper_152",
    value:
      "Forestry & Paper - 152 Manufacture of Containers of Paper and Paperboard",
  },
  {
    key: "forestry_paper_159",
    value: "Forestry & Paper - 159 Manufacture of Other Paper Products",
  },
  {
    key: "media_160",
    value: "Media - 160 Printing and Reproduction of Recorded Media",
  },
  {
    key: "oil_gas_170",
    value: "Oil & Gas - 170 Manufacture of Petroleum and Coal Products",
  },
  {
    key: "chemicals_181",
    value: "Chemicals - 181 Manufacture of Raw Chemical Material",
  },
  {
    key: "chemicals_183",
    value: "Chemicals - 183 Manufacture of Fertilizers and Nitrogen Compounds",
  },
  {
    key: "chemicals_184",
    value:
      "Chemicals - 184 Manufacture of Plastic and Synthetic Rubber Materials",
  },
  {
    key: "chemicals_185",
    value: "Chemicals - 185 Manufacture of Man-made Fibers",
  },
  {
    key: "chemicals_191",
    value: "Chemicals - 191 Manufacture of Pesticides and Environmental Agents",
  },
  {
    key: "chemicals_192",
    value: "Chemicals - 192 Manufacture of Coatings, Dyes and Pigments",
  },
  {
    key: "chemicals_193",
    value: "Chemicals - 193 Manufacture of Cleaning Preparations",
  },
  {
    key: "consumer_discretionary_products_194",
    value: "Consumer Discretionary Products - 194 Manufacture of Cosmetics",
  },
  {
    key: "chemicals_199",
    value:
      "Chemicals - 199 Manufacture of Other Chemical Products Not Elsewhere Classified",
  },
  {
    key: "biotechnology_pharma_200",
    value:
      "Biotechnology & Pharma - 200 Manufacture of Pharmaceuticals and Medicinal Chemical Products",
  },
  {
    key: "industrial_210",
    value: "Industrial - 210 Manufacture of Rubber Products",
  },
  {
    key: "industrial_220",
    value: "Industrial - 220 Manufacture of Plastics Products",
  },
  {
    key: "construction_materials_231",
    value:
      "Construction Materials - 231 Manufacture of Glass and Glass Products",
  },
  {
    key: "construction_materials_232",
    value:
      "Construction Materials - 232 Manufacture of Refractory Products, Clay Building Materials and Other Porcelain and Ceramic Products",
  },
  {
    key: "construction_materials_233",
    value:
      "Construction Materials - 233 Manufacture of Cement and Cement Products",
  },
  {
    key: "construction_materials_234",
    value:
      "Construction Materials - 234 Cutting, Shaping and Finishing of Stone",
  },
  {
    key: "construction_materials_239",
    value:
      "Construction Materials - 239 Manufacture of Other Non-metallic Mineral Products",
  },
  {
    key: "metals_mining_241",
    value: "Metals & Mining - 241 Manufacture of Basic Iron and Steel",
  },
  {
    key: "metals_mining_242",
    value: "Metals & Mining - 242 Manufacture of Aluminum",
  },
  {
    key: "metals_mining_243",
    value: "Metals & Mining - 243 Manufacture of Copper",
  },
  {
    key: "metals_mining_249",
    value: "Metals & Mining - 249 Manufacture of Other Basic Metals",
  },
  {
    key: "industrial_251",
    value: "Industrial - 251 Manufacture of Cutlery, Metal Hand Tools and Die",
  },
  {
    key: "industrial_252",
    value:
      "Industrial - 252 Manufacture of Metal Structure and Architectural Components",
  },
  {
    key: "industrial_253",
    value: "Industrial - 253 Manufacture of Metal Containers",
  },
  { key: "industrial_254", value: "Industrial - 254 Metalworking Activities" },
  {
    key: "industrial_259",
    value: "Industrial - 259 Manufacture of Other Fabricated Metal Products",
  },
  { key: "semicon_261", value: "Semicon - 261 Manufacture of Semi-conductors" },
  {
    key: "semicon_262",
    value: "Semicon - 262 Manufacture of Electronic Passive Devices",
  },
  {
    key: "semicon_263",
    value: "Semicon - 263 Manufacture of Bare Printed Circuit Boards",
  },
  {
    key: "semicon_264",
    value:
      "Semicon - 264 Manufacture of Optoelectronic Materials and Components",
  },
  {
    key: "semicon_269",
    value: "Semicon - 269 Manufacture of Other Electronic Parts and Components",
  },
  {
    key: "technology_271",
    value: "Technology - 271 Manufacture of Computers and Peripheral Equipment",
  },
  {
    key: "technology_272",
    value: "Technology - 272 Manufacture of Communication Equipment",
  },
  {
    key: "technology_273",
    value: "Technology - 273 Manufacture of Audio and Video Equipment",
  },
  {
    key: "technology_274",
    value: "Technology - 274 Manufacture of Magnetic and Optical Media",
  },
  {
    key: "technology_275",
    value:
      "Technology - 275 Manufacture of Measuring, Navigating, Control Equipment, Watches and Clocks",
  },
  {
    key: "technology_276",
    value:
      "Technology - 276 Manufacture of Irradiation and Electromedical Equipment",
  },
  {
    key: "technology_277",
    value: "Technology - 277 Manufacture of Optical Instruments and Equipment",
  },
  {
    key: "industrial_281",
    value:
      "Industrial - 281 Manufacture of Power Generation, Transmission and Distribution Machinery",
  },
  {
    key: "industrial_282",
    value: "Industrial - 282 Manufacture of Batteries and Accumulators",
  },
  {
    key: "industrial_283",
    value: "Industrial - 283 Manufacture of Wiring and Wiring Devices",
  },
  {
    key: "industrial_284",
    value: "Industrial - 284 Manufacture of Lighting Equipment",
  },
  {
    key: "consumer_goods_retail_285",
    value: "Consumer Goods Retail - 285 Manufacture of Domestic Appliances",
  },
  {
    key: "industrial_289",
    value: "Industrial - 289 Manufacture of Other Electrical Equipment",
  },
  {
    key: "industrial_291",
    value: "Industrial - 291 Manufacture of Metalworking Machinery",
  },
  {
    key: "industrial_292",
    value: "Industrial - 292 Manufacture of Other Special-purpose Machinery",
  },
  {
    key: "industrial_293",
    value: "Industrial - 293 Manufacture of General-purpose Machinery",
  },
  {
    key: "automobiles_301",
    value: "Automobiles - 301 Manufacture of Motor Vehicles",
  },
  {
    key: "automobiles_302",
    value:
      "Automobiles - 302 Manufacture of Bodies (Coachwork) for Motor Vehicles",
  },
  {
    key: "automobiles_303",
    value: "Automobiles - 303 Manufacture of Parts for Motor Vehicles",
  },
  {
    key: "marine_transportation_311",
    value:
      "Marine Transportation - 311 Manufacture of Ships, Boats and Floating Structures",
  },
  {
    key: "land_transportation_312",
    value: "Land Transportation - 312 Manufacture of Motorcycles and Parts",
  },
  {
    key: "land_transportation_313",
    value: "Land Transportation - 313 Manufacture of Bicycles and Parts",
  },
  {
    key: "industrial_319",
    value:
      "Industrial - 319 Manufacture of Other Transport Equipment and Parts Not Elsewhere Classified",
  },
  {
    key: "consumer_discretionary_products_321",
    value:
      "Consumer Discretionary Products - 321 Manufacture of Non-metallic Furniture",
  },
  {
    key: "consumer_discretionary_products_322",
    value:
      "Consumer Discretionary Products - 322 Manufacture of Metallic Furniture",
  },
  {
    key: "consumer_discretionary_products_331",
    value:
      "Consumer Discretionary Products - 331 Manufacture of Sports and Recreational Goods",
  },
  {
    key: "health_care_provider_332",
    value:
      "Health Care Provider - 332 Manufacture of Medical Instruments and Supplies",
  },
  {
    key: "consumer_discretionary_products_339",
    value:
      "Consumer Discretionary Products - 339 Manufacturing Not Elsewhere Classified",
  },
  { key: "air_transportation", value: "Air Transportation" },
  { key: "alternative_energy", value: "Alternative Energy" },
  { key: "capital_market", value: "Capital Market" },
  { key: "coal", value: "Coal" },
  { key: "consumer_services", value: "Consumer Services" },
  { key: "corporate_retail_banking", value: "Corporate & Retail Banking" },
  { key: "food_beverage_retail", value: "Food & Beverage Retail" },
  { key: "health_care_retail", value: "Health Care Retail" },
  { key: "hospitality_recreation", value: "Hospitality & Recreation" },
  { key: "infrastructure", value: "Infrastructure" },
  { key: "internet_media_services", value: "Internet Media & Services" },
  { key: "media_technology", value: "Media Technology" },
  { key: "real_estate", value: "Real Estate" },
  { key: "restaurants", value: "Restaurants" },
  { key: "telecommunications", value: "Telecommunications" },
  { key: "utilities", value: "Utilities" },
  { key: "waste_management", value: "Waste Management" },
  { key: "others", value: "Others" },
];

export const ORG_BOUNDARY = [
  { key: "operational_control", value: "Operational Control approach" },
  { key: "financial_control", value: "Financial Control approach" },
  { key: "equity_share", value: "Equity Share approach" },
];

export const REPORT_STANDARD = [
  { key: "iso_14064_1", value: "ISO 14064-1" },
  { key: "ghg_protocol", value: "GHG Protocol" },
];

export const MATERIALITY_ASSESSMENT_CRITERIA = [
  {
    key: "data_credibility",
    label: "Data Credibility",
    options: [
      {
        key: "third_party_evidence",
        label: "With supporting evidence from third party",
        score: 5,
      },
      {
        key: "internal_system_reports",
        label: "Internal finance or procurement system reports",
        score: 3,
      },
      {
        key: "signed_internal_records",
        label: "Relevant operation records that have been signed internally",
        score: 1,
      },
      {
        key: "no_records",
        label: "No records",
        score: 0,
      },
    ],
  },
  {
    key: "emission_factor_sources",
    label: "Emission factor sources",
    options: [
      {
        key: "in_house_measurement_coefficient",
        label: "In-house measurement coefficient",
        score: 5,
      },
      {
        key: "manufacturer_coefficient",
        label: "Coefficient provided by the equipment manufacturer",
        score: 4,
      },
      {
        key: "regional_emission_factor",
        label: "Regional emission factor",
        score: 3,
      },
      {
        key: "national_emission_factor",
        label: "National emission factor",
        score: 2,
      },
      {
        key: "international_emission_factor",
        label: "International emission factor",
        score: 1,
      },
      {
        key: "no_emission_factor",
        label: "No emission factor",
        score: 0,
      },
    ],
  },
  {
    key: "emission_reduction_technology_implementation_feasibility",
    label: "Emission reduction technology implementation feasibility",
    options: [
      {
        key: "emission_reduction_1",
        label: "Emission reduction can be observed within 1 year",
        score: 5,
      },
      {
        key: "emission_reduction_2",
        label: "Emission reduction can be observed between 1 to 2 years",
        score: 4,
      },
      {
        key: "emission_reduction_3",
        label: "Emission reduction can be observed between 3 to 5 years",
        score: 3,
      },
      {
        key: "emission_reduction_4",
        label:
          "Emission reduction can be observed after 6 years from implementation",
        score: 2,
      },
      {
        key: "unable_to_observe_emission_reduction",
        label: "Unable to observe emission reduction",
        score: 1,
      },
    ],
  },
  {
    key: "occurrence_frequency",
    label: "Occurrence frequency",
    options: [
      { key: "monthly", label: "At least once a month", score: 5 },
      { key: "quarterly", label: "At least once a quarter", score: 3 },
      { key: "yearly", label: "At least once a year", score: 1 },
      { key: "not_consider", label: "Not Consider", score: 0 },
    ],
  },
  {
    key: "emission_volume",
    label: "Emission volume",
    options: [
      {
        key: "total_emissions_1",
        label: "Accounting for more than 3% of total emissions",
        score: 5,
      },
      {
        key: "total_emissions_2",
        label: "Accounting between 0.5% to 3% of total emissions",
        score: 3,
      },
      {
        key: "total_emissions_3",
        label: "Accounting for less than 0.5% of total emissions",
        score: 1,
      },
      {
        key: "not_consider",
        label: "Not Consider",
        score: 0,
      },
    ],
  },
];

export const SCOPE_CATEGORY = [
  {
    key: "1_1",
    value: "1.1 Stationary Combustion",
    category: "Scope 1 | Category 1",
  },
  {
    key: "1_2",
    value: "1.2 Mobile Combustion",
    category: "Scope 1 | Category 1",
  },
  {
    key: "1_3",
    value: "1.3 Direct GHG emissions & removals from industrial processes",
    category: "Scope 1 | Category 1",
  },
  {
    key: "1_4",
    value: "1.4 Fugitive Emissions",
    category: "Scope 1 | Category 1",
  },
  {
    key: "1_5",
    value: "1.5 Land Use, Land Use Change and Forestry (LULUCF)",
    category: "Scope 1 | Category 1",
  },
  {
    key: "2_1",
    value: "2.1 Imported Electricity",
    category: "Scope 1 | Category 2",
  },
  {
    key: "2_2",
    value: "2.2 Imported Energy",
    category: "Scope 1 | Category 2",
  },
  {
    key: "3_1",
    value: "3.1 Upstream Transport and Distribution for Goods",
    category: "Scope 1 | Category 3",
  },
  {
    key: "3_2",
    value: "3.2 Downstream Transport and Distribution for Goods",
    category: "Scope 1 | Category 3",
  },
  {
    key: "3_3",
    value: "3.3 Employee Commuting",
    category: "Scope 1 | Category 3",
  },
  {
    key: "3_4",
    value: "3.4 Client and Visitor Transport",
    category: "Scope 1 | Category 3",
  },
  {
    key: "3_5",
    value: "3.5 Business Travel",
    category: "Scope 1 | Category 3",
  },
  {
    key: "4_1",
    value: "4.1 Goods Purchased by an organization",
    category: "Scope 1 | Category 4",
  },
  {
    key: "4_2",
    value:
      "4.2 Capital Goods that are Purchased and Amortized by an Organization",
    category: "Scope 1 | Category 4",
  },
  {
    key: "4_3",
    value:
      "4.3 Disposal services (of solid or liquid waste) used by an organization",
    category: "Scope 1 | Category 4",
  },
  {
    key: "4_4",
    value: "4.4 Use of Assets (through leased equipment) by an Organization",
    category: "Scope 1 | Category 4",
  },
  {
    key: "4_5",
    value:
      "4.5 Use of Services not Described in the above sub-categories by an Organization",
    category: "Scope 1 | Category 4",
  },
  {
    key: "5_1",
    value: "5.1 Use Stage of the Product",
    category: "Scope 1 | Category 5",
  },
  {
    key: "5_2",
    value: "5.2 Downstream Leased Assets",
    category: "Scope 1 | Category 5",
  },
  {
    key: "5_3",
    value: "5.3 End of Life Stage of the Product",
    category: "Scope | Category 5",
  },
  { key: "5_4", value: "5.4 Investments", category: "Scope 1 | Category 5" },
  {
    key: "6_1",
    value: "6.1 GHG Emissions or Removals from Other Sources",
    category: "Scope 1 | Category 6",
  },
];

// Fixed range: 2026 through 2035
export const YEAR_OPTIONS = Array.from({ length: 10 }, (_, i) => {
  const year = 2026 + i;
  return { key: String(year), label: String(year) };
});

export const GHG_REPORT_PURPOSE = [
  { key: "compliance", value: "Compliance" },
  { key: "internal_reporting", value: "Internal Reporting" },
  { key: "stakeholders_requirement", value: "Stakeholders' Requirement" },
];

export const LEVEL_ASSURANCE = [
  { key: "limited_assurance", value: "Limited Assurance" },
  { key: "reasonable_assurance", value: "Reasonable Assurance" },
];

export const SBTI_TEMPERATURE = [
  { key: 1.5, value: "1.50°C" },
  { key: 2, value: "2.0°C" },
];

export const TARGET_TYPES = [
  { key: "absolute", value: "Absolute" },
  { key: "intensity", value: "Intensity" },
];

export const REGRESSION_MODELS = [
  {
    key: "ghg_15",
    value: "GHG (Kyoto Gases): Y = -0.31X + 2.70 (R² = 0.83) (targets < 15 y)",
    type: "absolute",
  },
  {
    key: "ghg_30",
    value: "GHG (Kyoto Gases): Y = -0.48X + 2.84 (R² = 0.93) (targets < 30 y)",
    type: "absolute",
  },
  {
    key: "co2_15",
    value:
      "CO₂ (Energy and Industrial Processes): Y = -0.31X + 2.62 (R² = 0.85) (targets < 15 y)",
    type: "absolute",
  },
  {
    key: "co2_30",
    value:
      "CO₂ (Energy and Industrial Processes): Y = 0.44X + 2.72 (R² = 0.9) (targets < 30 y)",
    type: "absolute",
  },

  {
    key: "ghg_gdp_15",
    value: "GHG/GDP: Y = -0.53X + 4.11 (R² = 0.83) (targets < 15 y)",
    type: "intensity",
  },
  {
    key: "ghg_gdp_30",
    value: "GHG/GDP: Y = -1.1X + 4.93 (R² = 0.9) (targets < 30 y)",
    type: "intensity",
  },
  {
    key: "co2_mwh_15",
    value:
      "CO₂/MWh (Electricity generation): Y = -0.33X + 3.33 (R² = 0.71) (targets < 15 y)",
    type: "intensity",
  },
  {
    key: "co2_mwh_30",
    value:
      "CO₂/MWh (Electricity generation): Y = -0.78X + 3.9 (R² = 0.89) (targets < 30 y)",
    type: "intensity",
  },
  {
    key: "co2_pe_15",
    value:
      "CO₂/PE (Primary energy): Y = -0.51X + 3.0 (R² = 0.75) (targets < 15 y)",
    type: "intensity",
  },
  {
    key: "co2_pe_30",
    value:
      "CO₂/PE (Primary energy): Y = 0.66X + 3.21 (R² = 0.84) (targets < 30 y)",
    type: "intensity",
  },
];

export const PERIOD_OPTION = [
  { key: "yearly", value: "Yearly" },
  { key: "quarterly", value: "Quarterly" },
  { key: "monthly", value: "monthly" },
];

export const ACTIVITY_ACTIONS = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  CREATE: "Created",
  UPDATE: "Updated",
  DELETE: "Deleted",
  SHARE: "Shared",
  SUBMIT: "Submitted",
};
export const ACTIVITY_MODULES = {
  AUTH: "Auth",
  ORGANIZATION: "Organization",
  EXPLORE: "Explore",
  SURVEYS: "Surveys",
  SETTINGS: "Settings",
  DASHBOARD: "Dashboard",
  COMPANY_INFORMATION: "Company Information",
  ROLESANDPERMISSIONS: "Roles and Permissions",
};

export const ROLES = {
  BUSINESS_UNIT: "business_unit",
  SYSTEM_ADMIN: "system_admin",
  SUPER_ADMIN: "super_admin",
  RESELLER: "reseller",
  SOLUTION_PROVIDER: "solution_provider",
};

export const BU_CATEGORY = [
  { key: "HLD", value: "Group" },
  { key: "TEC", value: "Technology" },
  { key: "PKG", value: "Packaging" },
  { key: "MSM", value: "Mobility, Beverage & Industry" },
  { key: "LSC", value: "Industrial Engineering" },
  { key: "GMA", value: "Industrial Garnet" },
  { key: "ING", value: "Ingredients" },
  { key: "CAT", value: "Connectivity Solutions (JJ-LAPP, sold)" },
];
